export type ChangeEventPayload = {
  value: string;
};

export type ReactNativeDetectNotePitchViewProps = {
  name: string;
};
